export default __webpack_public_path__ + "static/media/wood-creature.35742716.png";